import { CsvColumnSeparator } from '../../enums/file-reader/csv-column-separators';
import { CsvWriterColumnProps } from './csv-writer-column-props';
import { FileWriterBase } from './file-writer-base';

/**
 * Writer configuration for CSV files. Extends FileWriterBase with CSV-specific
 * header, delimiter, and column mapping settings.
 */
export class CsvWriterProps extends FileWriterBase {
	/**
	 * Whether to include a header row as the first line of the CSV. @default false
	 */
	includeHeaderRow = false;
	/**
	 * Column delimiter. 0=comma, 1=semicolon, 2=pipe, 3=colon, 4=period.
	 * @default CsvColumnSeparator[',']
	 */
	columnSeparator = CsvColumnSeparator[','];
	/**
	 * Column output definitions. Each entry maps a source field to a CSV column.
	 * valueType: Field=1 (reads from processingData), FreeTextOrExpression=2 (literal/expression).
	 * @default []
	 */
	rowConfig: CsvWriterColumnProps[] = [];

	constructor(init?: Partial<CsvWriterProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
